import { useMemo } from 'react';

import { useMarketingSources } from './use-url-params';

export function useUserTags() {
    const marketingSources = useMarketingSources();

    return useMemo(() => {
        const marketingTags = marketingSources.map((item) => {
            return { name: 'source', value: item };
        });

        // TODO: This will temporary simulate data coming from profile tag service
        // TODO: create a selector to get user tags - to be uncommented
        // https://github.com/GiGInnovationLabs/dragon/issues/72
        const userAccountTags = [
            { name: 'segment', value: 'vip' },
            { name: 'vertial', value: 'casino' },
        ];

        return [...marketingTags, ...userAccountTags].map(({ name, value }) => {
            return [name, value].filter((tagPart) => !!tagPart).join(':');
        });
    }, [marketingSources]);
}
